import { Flex, Skeleton } from "antd";
import { cn } from "../../../utils/global.utils";

export default function CourseCurriculumLoading() {
  return (
    <div className="rounded-lg shadow-sm bg-theme-slate-25 border border-theme-zinc-200">
      <div className="bg-white">
        {[1, 2, 3, 4].map((item, index) => (
          <div
            key={item}
            className={cn(
              "border-b border-gray-200 p-4",
              index === 3 && "border-b-0"
            )}
          >
            {/* Header Skeleton */}
            <Flex justify="space-between" align="center" className="mb-0">
              <Skeleton.Input active size="default" className="!w-64" />
              <Skeleton.Input
                active
                size="small"
                className="!w-24 relative -left-5"
              />
            </Flex>

            {/* Content Skeleton - Only show for first item (expanded) */}
            {index === 0 && (
              <div className="pt-4 pb-2">
                <ul className="space-y-2">
                  {[1, 2, 3].map((lectureItem) => (
                    <li
                      key={lectureItem}
                      className="flex items-center gap-3 py-2"
                    >
                      <Skeleton.Avatar
                        active
                        size="small"
                        shape="square"
                        className="!w-4 !h-4 relative -top-1"
                      />
                      <Flex justify="space-between" className="w-full">
                        <Skeleton.Input active size="small" className="!w-48" />
                        <Skeleton.Input
                          active
                          size="small"
                          className="!w-24 relative -left-5"
                        />
                      </Flex>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
